import React from 'react'
import { Link } from 'react-router-dom'
import styledComponents from '../styles/Header-style.js'
const { CustomHeader, CustomLogo, LogoWrapper, LogoImg, LocationTitle, LogoTitle, LocationTitleCoreArea, AboutWrapper } = styledComponents;

const Header = (props) => {
    const { SelectedAreaName, menu, SelectedTabId, isTable, TableAreaName } = props;

    return (
        <CustomHeader>
            <CustomLogo>
                <LogoWrapper>
                    <Link to="/">
                        <LogoImg alt="BlueCarbon" src="./images/BCLogo.svg" />
                    </Link>
                    <Link to="/"><LogoTitle>국가 블루카본 정보시스템</LogoTitle>
                    </Link>
                </LogoWrapper>
                <LogoWrapper>
                <Link to="/about">
                    <AboutWrapper>About 블루카본</AboutWrapper>
                </Link>
                <a href="/eng" style={ {marginLeft: "5px"} }>
                    <AboutWrapper>ENG</AboutWrapper>
                </a>
                </LogoWrapper>
            </CustomLogo>
            {SelectedTabId !== 2 &&
                <LocationTitle>
                    {menu !== 3 ? (SelectedAreaName ? SelectedAreaName : '대한민국') : ''}                    
                    {menu === 0 && <span>갯벌</span>}
                    {menu === 1 && <span>해초대</span>}
                    {menu === 2 && <span>염습지</span>}
                    {menu === 3 && <span>게시판</span>}
                </LocationTitle>
            }
            {SelectedTabId === 2 &&
                <>
                    {!isTable &&
                        <LocationTitleCoreArea>
                            {menu !== 3 && '핵심지역'}
                            {menu === 0 && <span>현장조사 리포트</span>}
                            {menu === 1 && <span>현장조사 리포트</span>}
                            {menu === 2 && <span>현장조사 리포트</span>}
                            {menu === 3 && <span></span>}
                        </LocationTitleCoreArea>
                    }
                    {isTable &&
                        <LocationTitle>
                            {TableAreaName ? TableAreaName : '대한민국'}
                            <span>현장조사 리포트</span>
                        </LocationTitle>
                    }
                </>
            }
        </CustomHeader >
    )
}

export default Header;